import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * A named exit point from an ExecuteFlow sub-flow. When the sub-flow reaches
 * the task identified by taskName, execution routes back to the parent flow
 * via successMappingID.
 */
export class FlowEnding extends DestinationTaskConfigBase {
	/** Human-readable label for this exit point (e.g. 'Success', 'Error'). */
	label: string;

	/** The name/identifier of the terminal task in the sub-flow that triggers this ending. */
	taskName: string;

	constructor(init: Partial<FlowEnding>) {
		super();
		if (!init.label) {
			throw new Error('Missing required property label');
		}
		if (!init.taskName) {
			throw new Error('Missing required property task name');
		}
		this.label = init.label;
		this.taskName = init.taskName;
		Object.assign(this, init);
	}
}
